<div class="col-sm-12 col-md-8">
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-one-half">
      <form [formGroup]="facilityForm" *ngIf="showFa">
        <div class="govuk-form-group">
          <label class="govuk-label govuk-fieldset__legend--m" for="change_venue">
            Change venue
          </label>
          <select (change)="onChangeFacility()" formControlName="selectedFacility" class="govuk-select"
            id="change_venue" name="change_venue">
            <option *ngIf="!showCalendar" value=""></option>
            <option *ngFor="let option of facilities" [value]="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="col-sm-12 col-md-8 mt-3">
  <!-- <div>
    <span *ngIf="adminJourney">
      <label style="font-size: 19px">
        <input style="width: 19px; height: 19px; margin: 10px" type="checkbox" [ngModel]="adminToggleDateRestrictions"
          (change)="reRun(true)" />
        Override availability</label> 
    </span>
  </div> -->
  <div class="calendar" *ngIf="availableDays && showCalendar">
    <div class="inner-div">

      <mat-calendar #calendar [selected]="selectedDate" [startAt]="startDate" [minDate]="minDate" [maxDate]="maxDate"
        (selectedChange)="updateSlots($event)" [dateFilter]="unavailableDates" [headerComponent]="customHeader">
      </mat-calendar>

      <div class="availability-markers">
        <span class="available" aria-hidden="true" title="Available">&#10003;</span>
        <span class="mr-4">{{ 'CALENDAR.KEY_AVAILABLE' | translate }}</span>
        <span class="unavailable" aria-hidden="true"
          title="Unavailable or not yet released">&#10060;</span>
        <span>{{ 'CALENDAR.KEY_UNAVAILABLE' | translate }}</span>
      </div>
    </div>
  </div>

  <button type="submit fr" class="govuk-button govuk-button--inverse next-btn" (click)="emitNextClicked()">
    {{ 'COMMON.NEXT' | translate }}
  </button>
</div>

<div class="col-sm-12 col-md-4 mt-3" *ngIf="availableDays && showCalendar">
  <div class="row">
    <div class="col-sm-12">
      <h2 class="heading-sm">
        <div aria-live="polite" class="sr-only" id="dateTimeAnnouncement">
          You have selected
          {{ selectedDate | date: 'EEEE d MMMM' : '' : translateService.currentLang }},
          at {{ datastoreService.selectedSlot?.displayTime }}
        </div>
      </h2>

      <dl class="body-xl">
        <dt class="label">Date</dt>
        <dd>
          {{
          selectedDate
          | date : 'EEEE d MMMM' : '' : translateService.currentLang
          }}
        </dd>
        <dt class="label">Time</dt>
        <dd>
          {{ selectedSlot?.displayTime }}
        </dd>

        <dt class="label">Appointment length</dt>
        <dd>
          {{ service.calculated_duration }} minutes
        </dd>

      </dl>
    </div>
  </div>

  <fieldset>
    <legend class="govuk-visually-hidden">Available time slots for {{ selectedDate | date }}</legend>
    <div class="row">
      <div class="col-sm-12">
        <span *ngIf="slots?.length === 0" tabindex="0">
          {{ 'CALENDAR.NO_SLOTS_WARNING' | translate }}
        </span>
      </div>
    </div>

    <div class="row desktop-scroll" [ngClass]="{'govuk-form-group--error': !selectedSlot && slotSelectionError}">
      <p *ngIf="!selectedSlot && slotSelectionError" id="time-selection-error" class="govuk-error-message"
        style="font-size: 19px">
        Please select a time slot to continue
      </p>
      <div *ngFor="let slot of slots" class="col-sm-6 col-md-4 col-lg-4">
        <button class="slot-btn btn btn-outline" (click)="selectSlot(slot)"
          [ngClass]="{ 'selected-slot-btn': selectedSlot?.start === slot?.start }"
          [attr.aria-pressed]="selectedSlot?.start === slot?.start">
          {{ slot?.displayTime }}
        </button>
      </div>
    </div>
  </fieldset>
</div>